/**
 * Formats a decimal hour value into a human-readable "Xh Ym" string.
 * Examples: 1.5 → "1h 30m", 0.6667 → "0h 40m", 2 → "2h", -1.25 → "-1h 15m"
 */
export const formatHoursDisplay = (value?: number): string => {
  const numeric = Number.isFinite(value) ? Number(value) : 0;
  const sign = numeric < 0 ? "-" : "";
  const abs = Math.abs(numeric);
  const hours = Math.floor(abs);
  let minutes = Math.round((abs - hours) * 60);
  let adjustedHours = hours;
  if (minutes === 60) {
    adjustedHours += 1;
    minutes = 0;
  }
  if (minutes === 0) return `${sign}${adjustedHours}h`;
  return `${sign}${adjustedHours}h ${minutes}m`;
};
